__turbopack_context__.v({
  "body": "ConfirmModal-module-scss-module__9akgXa__body",
  "content": "ConfirmModal-module-scss-module__9akgXa__content",
  "description": "ConfirmModal-module-scss-module__9akgXa__description",
  "title": "ConfirmModal-module-scss-module__9akgXa__title",
  "trigger": "ConfirmModal-module-scss-module__9akgXa__trigger",
});
